import React, { useState, useEffect, useContext } from 'react'
import { useParams } from 'react-router-dom'
import InvoiceStatusHelper from '../helpers/InvoiceStatusHelper'
import InvoiceStatus from './InvoiceStatus'
import OneClickPaymentApi from '../services/api/OneClickPayment'
import BankIDSign from './BankIDSign'
import PaymentSuccess from './PaymentSuccess'
import OneClickPaymentText from './OneClickPaymentText'
import DirectDebitConsentApi from '../services/api/DirectDebitConsent'
import DirectDebitConsent from './DirectDebitConsent'
import LoadingComponent from './LoadingComponent'
import Context from '../context/Context'
import PropTypes from 'prop-types'
import { ConsentStatuses } from '../helpers/Constants'
import { BackButton } from '../utils/Elements'
import { useTranslation } from 'react-i18next'

const OneClickPayment = ({ bankIDCollectResponse }) => {
  const context = useContext(Context)
  const { id, sign } = useParams()
  const [paymentResult, setPaymentResult] = useState({})
  const [consent, setConsent] = useState({})
  const [consentsLoaded, setConsentsLoaded] = useState(false)
  const [error, setError] = useState('')

  const { t } = useTranslation()

  const AbortController = window.AbortController
  const abortController = new AbortController()

  const paymentApprovalTypeId = id
  const signingActionId = sign
  const signal = abortController.signal

  useEffect(() => {
    const directDebitConsentApi = new DirectDebitConsentApi()
    directDebitConsentApi.get(context.invoice.ocr, signal)
      .then(res => res.json())
      .then(data => {
        Object.entries(data).forEach(([key, value]) => {
          const consentStatus = parseInt(value.misc.consent_status_id)

          if (
            consentStatus === ConsentStatuses.APPROVED ||
            consentStatus === ConsentStatuses.REGISTERED
          ) {
            setConsent(value)
          }
        })

        setConsentsLoaded(true)
      })
      .catch(error => {
        console.error(error.message)
      })

    return () => null
  }, [])

  useEffect(() => {
    if (
      bankIDCollectResponse &&
      Object.keys(bankIDCollectResponse).length > 0 &&
      bankIDCollectResponse.status === 'complete' &&
      Object.keys(consent).length > 0 &&
      Object.keys(paymentResult).length === 0
    ) {
      const oneClickPaymentApi = new OneClickPaymentApi()
      oneClickPaymentApi.post(
        paymentApprovalTypeId,
        context.invoice.ocr,
        bankIDCollectResponse.bankIdLogId,
        signal
      )
        .then(res => res.json())
        .then(data => {
          setPaymentResult(data)
          if (data.short_code >= '400') {
            setError(t(data.message))
          }
        })
    }

    return () => null
  }, [consent])

  const textToSign = `Jag godkänner betalning av faktura ${context.invoice.ocr} med totalsumman ${context.invoice.remaining_amount} kr.`

  const PaymentRequestError = () => {
    return (
      <div>
        <div className="row mt-2 m-auto">
          <div className="col-12 text-center text-danger">
            <p>{ (error !== '') ? error : 'Tyvärr går det inte att betala fakturan, vänligen kontakta kundtjänst.'}</p>
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-12 text-center">
            <BackButton style={context.style} />
          </div>
        </div>
      </div>
    )
  }

  if (InvoiceStatusHelper.shouldInvoiceBePaid(context.invoice)) {
    if (bankIDCollectResponse && bankIDCollectResponse.status === 'complete') {
      if (paymentResult.short_code === '201') {
        return (
          <div>
            <PaymentSuccess />
            <div className="row mt-3">
              <div className="col-12 text-center">
                <span className="paragraph-regular-18"><OneClickPaymentText paymentApprovalTypeId={paymentApprovalTypeId} /></span>
              </div>
            </div>
          </div>
        )
      } else if (paymentResult.short_code >= 400) {
        return <PaymentRequestError />
      } else {
        return <LoadingComponent />
      }
    } else {
      if (consentsLoaded) {
        if (!consent || Object.keys(consent).length === 0) {
          return <DirectDebitConsent />
        } else {
          return <BankIDSign
            paymentApprovalTypeId={paymentApprovalTypeId}
            textToSign={textToSign}
            whatIsSigned={'oneClickPayment'}
            socialId={consent.soc_id}
            signingActionId={parseInt(signingActionId)}
          />
        }
      } else {
        return <LoadingComponent />
      }
    }
  } else {
    return <InvoiceStatus />
  }
}

OneClickPayment.propTypes = {
  bankIDCollectResponse: PropTypes.object
}

export default OneClickPayment
